import { NgModule } from '@angular/core';
import { HeaderComponent } from './layout/header/header.component';
import { CommonModule } from '@angular/common';
import { MaterialModule } from './common/material.module';
import { NgxSpinnerModule } from 'ngx-spinner';
import { PopUpComponent } from './layout/pop-up/pop-up.component';
import { LmsSelectComponent } from './layout/lms-select/lms-select.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EditorComponent } from './layout/editor/editor.component';
import { CKEditorModule } from 'ng2-ckeditor';
import { WebSpeechComponent } from './layout/web-speech/web-speech.component';
import { LabelFormControlDirective } from './directive/label-form-control.directive';
import { FirstLetterPipe } from './pipe/first-letter.pipe';
import { NumberToWordsPipe } from './pipe/number-to-words.pipe';
import { UnderMaintenanceComponent } from './component/under-maintenance/under-maintenance.component';
import { PageNotFoundComponent } from './component/page-not-found/page-not-found.component';
import { LinesShimmerComponent } from './shimmer/lines-shimmer/lines-shimmer.component';
import { BoxShimmerComponent } from './shimmer/box-shimmer/box-shimmer.component';
import { ImageShimmerComponent } from './shimmer/image-shimmer/image-shimmer.component';
import { BreadcrumbComponent } from './component/breadcrumb/breadcrumb.component';
import { CdkFilterListPipe } from './pipe/cdk-filter-list.pipe';
import { MiniCardComponent } from './component/mini-card/mini-card.component';
import { AccessDeniedComponent } from './component/access-denied/access-denied.component';

@NgModule({
  declarations: [
    HeaderComponent,
    PopUpComponent,
    LmsSelectComponent,
    EditorComponent,
    WebSpeechComponent,
    LabelFormControlDirective,
    FirstLetterPipe,
    NumberToWordsPipe,
    UnderMaintenanceComponent,
    PageNotFoundComponent,
    LinesShimmerComponent,
    BoxShimmerComponent,
    ImageShimmerComponent,
    BreadcrumbComponent,
    CdkFilterListPipe,
    MiniCardComponent,
    AccessDeniedComponent,
  ],
  imports: [
    CommonModule,
    MaterialModule,
    NgxSpinnerModule,
    FormsModule,
    ReactiveFormsModule,
    CKEditorModule,
  ],
  exports: [
    HeaderComponent,
    NgxSpinnerModule,
    FormsModule,
    ReactiveFormsModule,
    LmsSelectComponent,
    EditorComponent,
    WebSpeechComponent,
    FirstLetterPipe,
    MaterialModule,
    UnderMaintenanceComponent,
    PageNotFoundComponent,
    LinesShimmerComponent,
    BoxShimmerComponent,
    ImageShimmerComponent,
    BreadcrumbComponent,
    CdkFilterListPipe,
    MiniCardComponent,
    AccessDeniedComponent
  ],
  providers: [
    NumberToWordsPipe,
    CdkFilterListPipe
  ],
})
export class SharedModule { }
